<script context="module" lang="ts">
  export type CountrySelect = {
    lang?: string;
    regionCode?: string;
    countryCode: string;
    defaultLanguage?: string;
    languages?: string[];
  };
</script>

<script lang="ts">
  import { _ } from "svelte-i18n";
  import Dropdown from "$lib/components/Dropdown/Dropdown/Dropdown.svelte";
  import DropdownItem from "$lib/components/Dropdown/DropdownItem/DropdownItem.svelte";
  import { createEventDispatcher } from "svelte";
  import { getCountry } from "$lib/data/countries.data";
  import { getLanguages, getRegionsData } from "$lib/data/regionSelector.data";
  import type { LangData, CountryData } from "$lib/data/regionSelector.data";
  import Typography from "$lib/components/Typography/Typography.svelte";

  export let selectedCountry: CountryData;
  export let selectedLanguage: LangData;

  let languagesList: LangData[];

  $: languagesList =
    selectedCountry &&
    selectedCountry.languages &&
    selectedCountry.languages.map(l => getLanguages(l));

  const regionsData = getRegionsData();

  const dispatch = createEventDispatcher<{
    selectedCountry: CountrySelect;
    selectedLanguage: {
      code: string;
      label: string;
    };
  }>();

  const regions = regionsData
    .map(r => {
      return r.countries.map(country => {
        return {
          ...country,
          regionCode: country.regionCode || r.regionCode,
          label: getCountry(country.countryCode),
          langList: country.languages.map(l => getLanguages(l)),
        };
      });
    })
    .flat()
    .sort((a, b) =>
      getCountry(a.countryCode).localeCompare(getCountry(b.countryCode)),
    );
</script>

<Typography variant="overline">{$_("Confirm delivery region")}</Typography>
<Dropdown
  label={$_("Country / Region")}
  selectedItem={selectedCountry && getCountry(selectedCountry.countryCode)}
  capitalised
>
  {#each regions as r}
    <DropdownItem
      countryCode={r.countryCode}
      on:click={() => {
        selectedCountry = r;
        languagesList = r.langList;
        dispatch("selectedCountry", {
          countryCode: r.countryCode,
          regionCode: r.regionCode,
          languages: r.languages.length === 1 ? [r.languages[0]] : r.languages,
          defaultLanguage: r.defaultLanguage && r.defaultLanguage,
        });
      }}
      label={r.label.toLowerCase()}
    />
  {/each}
</Dropdown>

<Typography variant="overline">{$_("Confirm preferred language")}</Typography>
<Dropdown
  label={$_("Language")}
  selectedItem={selectedLanguage && selectedLanguage.label}
  disabled={!selectedCountry}
>
  {#if languagesList}
    {#each languagesList as language}
      <DropdownItem
        on:click={() => {
          selectedLanguage = language;
          dispatch("selectedLanguage", language);
        }}
        label={language.label}
      />
    {/each}
  {/if}
</Dropdown>
